/* src/app/shared/protocolo-arquivos/protocolo-pesquisa.component.scss */
/*# sourceMappingURL=protocolo-pesquisa.component.css.map */
